import { Response } from '@angular/http';
// import { HttpClient } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

import { environment } from '../../../environments/environment';
import { Router } from "@angular/router";


@Injectable()
export class AuthService {


    constructor(private http: HttpClient, private router: Router) {}

    login(data) {
        return this.http.post(environment.apiLoginUrl, data)
        .map(function (res: Response | any) {
            return res;
        });
    }

    logout() {
        localStorage.removeItem('passportToken');
        localStorage.removeItem('user');
        localStorage.removeItem('lockEnabled');
        localStorage.removeItem('userConfig');
    }

    getPassportToken(){
        return localStorage.getItem('passportToken');
    }

    recoveryRequest(req){
        return this.http.post(environment.apiUrl + 'session/requestRecovery', req)
        .map(function(res: Response){
            return res;
        })
        .catch(function(error: Response | any) {
            return Observable.throw(error);
        });
    }

    verifyRecoveryKey(key){
        return this.http.get(environment.apiUrl + 'session/verifyRecoveryKey/' + key)
        .map(function(res: Response){
            return res;
        })
        .catch(function(error: Response | any) {
            return Observable.throw(error);
        });
    }

    resetPassword(password){
        return this.http.post(environment.apiUrl + 'session/resetPassword', password)
        .map(function(res: Response){
            return res;
        })
        .catch(function(error: Response | any) {
            return Observable.throw(error);
        });
    }


    authenticate(token, user, config) {
        localStorage.setItem('passportToken', token);
        this.saveUser(user);
        this.saveConfig(config);
    }

    requestLogin(){
        this.logout();
        this.router.navigate(['/']);
    }

    authenticated() {
        return (localStorage.getItem('passportToken')) ? true : false;
    }



    locked(){
        return localStorage.getItem('lockEnabled') ? true : false;
    }

    lock(){
        localStorage.setItem('lockEnabled', '1');
    }

    unlock(data){
        return this.http.post(environment.apiUrl + 'session/unlock', data)
        .map(function(res: any){
            let responseJson = res;

            if(responseJson.success){
                localStorage.removeItem('lockEnabled');
            }

            return responseJson;
        })
        .catch(function(error: Response | any) {
            return Observable.throw(error);
        });
    }

    saveUser(user) {
        localStorage.setItem('user', JSON.stringify(user));
    }

    getUser() {return JSON.parse(localStorage.getItem('user'));
    }

    saveConfig(config){
        localStorage.setItem('userConfig', JSON.stringify(config));
    }

    getConfig(){
        return JSON.parse(localStorage.getItem('userConfig'));
    }

    getTimezone(){
        return this.getConfig().timezone;
    }

    userIsAdmin() {
        let user = this.getUser();
        return (user.rol_id == 1 || user.rol_id == 2) ? true : false;
    }

}



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/auth.service.ts